import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative w-full',
    button: 'group disabled:text-inactive size-6 bg-transparent p-0',
    icon: 'group-pressed:-scale-100 rotate-90 transition-transform duration-150',
    input: ''
  },
  variants: {
    noInput: {
      true: {
        input: 'cursor-pointer'
      }
    }
  }
});
